/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { CreateFileRoute, FileRoutesByPath } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/root'
import { Route as monitorMonitorDotpageRouteImport } from './routes/monitor/Monitor.page'
import { Route as dashboardDashboardDotpageRouteImport } from './routes/dashboard/Dashboard.page'
import { Route as NotFoundRouteImport } from './routes/NotFound'
import { Route as indexRouteImport } from './routes/index'
import { Route as authAuthLayoutRouteImport } from './routes/auth/AuthLayout'
import { Route as arcARCLayoutRouteImport } from './routes/arc/ARCLayout'
import { Route as authSignUpSignUpRouteImport } from './routes/auth/sign-up/SignUp'
import { Route as authSignInSignInRouteImport } from './routes/auth/sign-in/SignIn'
import { Route as authResetPasswordResetPasswordRouteImport } from './routes/auth/reset-password/ResetPassword'
import { Route as arcOfflineOfflineDotpageRouteImport } from './routes/arc/offline/Offline.page'
import { Route as arcSIPLayoutRouteImport } from './routes/arc/SIPLayout'
import { Route as arcHomeDotpageRouteImport } from './routes/arc/Home.page'
import { Route as arcStatisticsStatisticsDotpageRouteImport } from './routes/arc/statistics/Statistics.page'
import { Route as arcProfileProfileDotpageRouteImport } from './routes/arc/profile/Profile.page'
import { Route as arcAdminAdminDotpageRouteImport } from './routes/arc/admin/Admin.page'
import { Route as arcCallLayoutRouteImport } from './routes/arc/CallLayout'
import { Route as arcCallInCallInDotpageRouteImport } from './routes/arc/call-in/CallIn.page'
import { Route as arcAvailableAvailableDotpageRouteImport } from './routes/arc/available/Available.page'

const monitorMonitorDotpageRoute = monitorMonitorDotpageRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardDotpageRoute =
  dashboardDashboardDotpageRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const indexRoute = indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthLayoutRoute = authAuthLayoutRouteImport.update({
  id: '/auth/_AuthLayout',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const arcARCLayoutRoute = arcARCLayoutRouteImport.update({
  id: '/arc/_ARCLayout',
  path: '/arc',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpSignUpRoute = authSignUpSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => authAuthLayoutRoute,
} as any)
const authSignInSignInRoute = authSignInSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authAuthLayoutRoute,
} as any)
const authResetPasswordResetPasswordRoute =
  authResetPasswordResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => authAuthLayoutRoute,
  } as any)
const arcOfflineOfflineDotpageRoute =
  arcOfflineOfflineDotpageRouteImport.update({
    id: '/offline',
    path: '/offline',
    getParentRoute: () => arcARCLayoutRoute,
  } as any)
const arcSIPLayoutRoute = arcSIPLayoutRouteImport.update({
  id: '/_SIPLayout',
  getParentRoute: () => arcARCLayoutRoute,
} as any)
const arcHomeDotpageRoute = arcHomeDotpageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => arcARCLayoutRoute,
} as any)
const arcStatisticsStatisticsDotpageRoute =
  arcStatisticsStatisticsDotpageRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => arcSIPLayoutRoute,
  } as any)
const arcProfileProfileDotpageRoute =
  arcProfileProfileDotpageRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => arcSIPLayoutRoute,
  } as any)
const arcAdminAdminDotpageRoute = arcAdminAdminDotpageRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => arcSIPLayoutRoute,
} as any)
const arcCallLayoutRoute = arcCallLayoutRouteImport.update({
  id: '/call/_CallLayout',
  path: '/call',
  getParentRoute: () => arcSIPLayoutRoute,
} as any)
const arcCallInCallInDotpageRoute = arcCallInCallInDotpageRouteImport.update({
  id: '/calling',
  path: '/calling',
  getParentRoute: () => arcCallLayoutRoute,
} as any)
const arcAvailableAvailableDotpageRoute =
  arcAvailableAvailableDotpageRouteImport.update({
    id: '/available',
    path: '/available',
    getParentRoute: () => arcCallLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof indexRoute
  '/404': typeof NotFoundRoute
  '/dashboard': typeof dashboardDashboardDotpageRoute
  '/monitor': typeof monitorMonitorDotpageRoute
  '/arc': typeof arcSIPLayoutRouteWithChildren
  '/auth': typeof authAuthLayoutRouteWithChildren
  '/arc/': typeof arcHomeDotpageRoute
  '/arc/offline': typeof arcOfflineOfflineDotpageRoute
  '/auth/reset-password': typeof authResetPasswordResetPasswordRoute
  '/auth/sign-in': typeof authSignInSignInRoute
  '/auth/sign-up': typeof authSignUpSignUpRoute
  '/arc/admin': typeof arcAdminAdminDotpageRoute
  '/arc/profile': typeof arcProfileProfileDotpageRoute
  '/arc/statistics': typeof arcStatisticsStatisticsDotpageRoute
  '/arc/call': typeof arcCallLayoutRouteWithChildren
  '/arc/call/available': typeof arcAvailableAvailableDotpageRoute
  '/arc/call/calling': typeof arcCallInCallInDotpageRoute
}
export interface FileRoutesByTo {
  '/': typeof indexRoute
  '/404': typeof NotFoundRoute
  '/dashboard': typeof dashboardDashboardDotpageRoute
  '/monitor': typeof monitorMonitorDotpageRoute
  '/auth': typeof authAuthLayoutRouteWithChildren
  '/arc': typeof arcSIPLayoutRouteWithChildren
  '/arc/offline': typeof arcOfflineOfflineDotpageRoute
  '/auth/reset-password': typeof authResetPasswordResetPasswordRoute
  '/auth/sign-in': typeof authSignInSignInRoute
  '/auth/sign-up': typeof authSignUpSignUpRoute
  '/arc/admin': typeof arcAdminAdminDotpageRoute
  '/arc/profile': typeof arcProfileProfileDotpageRoute
  '/arc/statistics': typeof arcStatisticsStatisticsDotpageRoute
  '/arc/call': typeof arcCallLayoutRouteWithChildren
  '/arc/call/available': typeof arcAvailableAvailableDotpageRoute
  '/arc/call/calling': typeof arcCallInCallInDotpageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof indexRoute
  '/404': typeof NotFoundRoute
  '/dashboard': typeof dashboardDashboardDotpageRoute
  '/monitor': typeof monitorMonitorDotpageRoute
  '/arc/_ARCLayout': typeof arcARCLayoutRouteWithChildren
  '/auth/_AuthLayout': typeof authAuthLayoutRouteWithChildren
  '/arc/_ARCLayout/': typeof arcHomeDotpageRoute
  '/arc/_ARCLayout/_SIPLayout': typeof arcSIPLayoutRouteWithChildren
  '/arc/_ARCLayout/offline': typeof arcOfflineOfflineDotpageRoute
  '/auth/_AuthLayout/reset-password': typeof authResetPasswordResetPasswordRoute
  '/auth/_AuthLayout/sign-in': typeof authSignInSignInRoute
  '/auth/_AuthLayout/sign-up': typeof authSignUpSignUpRoute
  '/arc/_ARCLayout/_SIPLayout/admin': typeof arcAdminAdminDotpageRoute
  '/arc/_ARCLayout/_SIPLayout/profile': typeof arcProfileProfileDotpageRoute
  '/arc/_ARCLayout/_SIPLayout/statistics': typeof arcStatisticsStatisticsDotpageRoute
  '/arc/_ARCLayout/_SIPLayout/call/_CallLayout': typeof arcCallLayoutRouteWithChildren
  '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available': typeof arcAvailableAvailableDotpageRoute
  '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling': typeof arcCallInCallInDotpageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/dashboard'
    | '/monitor'
    | '/arc'
    | '/auth'
    | '/arc/'
    | '/arc/offline'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/arc/admin'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/call'
    | '/arc/call/available'
    | '/arc/call/calling'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/dashboard'
    | '/monitor'
    | '/auth'
    | '/arc'
    | '/arc/offline'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/arc/admin'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/call'
    | '/arc/call/available'
    | '/arc/call/calling'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/dashboard'
    | '/monitor'
    | '/arc/_ARCLayout'
    | '/auth/_AuthLayout'
    | '/arc/_ARCLayout/'
    | '/arc/_ARCLayout/_SIPLayout'
    | '/arc/_ARCLayout/offline'
    | '/auth/_AuthLayout/reset-password'
    | '/auth/_AuthLayout/sign-in'
    | '/auth/_AuthLayout/sign-up'
    | '/arc/_ARCLayout/_SIPLayout/admin'
    | '/arc/_ARCLayout/_SIPLayout/profile'
    | '/arc/_ARCLayout/_SIPLayout/statistics'
    | '/arc/_ARCLayout/_SIPLayout/call/_CallLayout'
    | '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available'
    | '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  indexRoute: typeof indexRoute
  NotFoundRoute: typeof NotFoundRoute
  dashboardDashboardDotpageRoute: typeof dashboardDashboardDotpageRoute
  monitorMonitorDotpageRoute: typeof monitorMonitorDotpageRoute
  arcARCLayoutRoute: typeof arcARCLayoutRouteWithChildren
  authAuthLayoutRoute: typeof authAuthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/monitor': {
      id: '/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof monitorMonitorDotpageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dashboardDashboardDotpageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof indexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_AuthLayout': {
      id: '/auth/_AuthLayout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc/_ARCLayout': {
      id: '/arc/_ARCLayout'
      path: '/arc'
      fullPath: '/arc'
      preLoaderRoute: typeof arcARCLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_AuthLayout/sign-up': {
      id: '/auth/_AuthLayout/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof authSignUpSignUpRouteImport
      parentRoute: typeof authAuthLayoutRoute
    }
    '/auth/_AuthLayout/sign-in': {
      id: '/auth/_AuthLayout/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof authSignInSignInRouteImport
      parentRoute: typeof authAuthLayoutRoute
    }
    '/auth/_AuthLayout/reset-password': {
      id: '/auth/_AuthLayout/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof authResetPasswordResetPasswordRouteImport
      parentRoute: typeof authAuthLayoutRoute
    }
    '/arc/_ARCLayout/offline': {
      id: '/arc/_ARCLayout/offline'
      path: '/offline'
      fullPath: '/arc/offline'
      preLoaderRoute: typeof arcOfflineOfflineDotpageRouteImport
      parentRoute: typeof arcARCLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout': {
      id: '/arc/_ARCLayout/_SIPLayout'
      path: ''
      fullPath: '/arc'
      preLoaderRoute: typeof arcSIPLayoutRouteImport
      parentRoute: typeof arcARCLayoutRoute
    }
    '/arc/_ARCLayout/': {
      id: '/arc/_ARCLayout/'
      path: '/'
      fullPath: '/arc/'
      preLoaderRoute: typeof arcHomeDotpageRouteImport
      parentRoute: typeof arcARCLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/statistics': {
      id: '/arc/_ARCLayout/_SIPLayout/statistics'
      path: '/statistics'
      fullPath: '/arc/statistics'
      preLoaderRoute: typeof arcStatisticsStatisticsDotpageRouteImport
      parentRoute: typeof arcSIPLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/profile': {
      id: '/arc/_ARCLayout/_SIPLayout/profile'
      path: '/profile'
      fullPath: '/arc/profile'
      preLoaderRoute: typeof arcProfileProfileDotpageRouteImport
      parentRoute: typeof arcSIPLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/admin': {
      id: '/arc/_ARCLayout/_SIPLayout/admin'
      path: '/admin'
      fullPath: '/arc/admin'
      preLoaderRoute: typeof arcAdminAdminDotpageRouteImport
      parentRoute: typeof arcSIPLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout': {
      id: '/arc/_ARCLayout/_SIPLayout/call/_CallLayout'
      path: '/call'
      fullPath: '/arc/call'
      preLoaderRoute: typeof arcCallLayoutRouteImport
      parentRoute: typeof arcSIPLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling': {
      id: '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling'
      path: '/calling'
      fullPath: '/arc/call/calling'
      preLoaderRoute: typeof arcCallInCallInDotpageRouteImport
      parentRoute: typeof arcCallLayoutRoute
    }
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available': {
      id: '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available'
      path: '/available'
      fullPath: '/arc/call/available'
      preLoaderRoute: typeof arcAvailableAvailableDotpageRouteImport
      parentRoute: typeof arcCallLayoutRoute
    }
  }
}

declare module './routes/index' {
  const createFileRoute: CreateFileRoute<
    '/',
    FileRoutesByPath['/']['parentRoute'],
    FileRoutesByPath['/']['id'],
    FileRoutesByPath['/']['path'],
    FileRoutesByPath['/']['fullPath']
  >
}
declare module './routes/NotFound' {
  const createFileRoute: CreateFileRoute<
    '/404',
    FileRoutesByPath['/404']['parentRoute'],
    FileRoutesByPath['/404']['id'],
    FileRoutesByPath['/404']['path'],
    FileRoutesByPath['/404']['fullPath']
  >
}
declare module './routes/dashboard/Dashboard.page' {
  const createFileRoute: CreateFileRoute<
    '/dashboard',
    FileRoutesByPath['/dashboard']['parentRoute'],
    FileRoutesByPath['/dashboard']['id'],
    FileRoutesByPath['/dashboard']['path'],
    FileRoutesByPath['/dashboard']['fullPath']
  >
}
declare module './routes/monitor/Monitor.page' {
  const createFileRoute: CreateFileRoute<
    '/monitor',
    FileRoutesByPath['/monitor']['parentRoute'],
    FileRoutesByPath['/monitor']['id'],
    FileRoutesByPath['/monitor']['path'],
    FileRoutesByPath['/monitor']['fullPath']
  >
}
declare module './routes/arc/ARCLayout' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout',
    FileRoutesByPath['/arc/_ARCLayout']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout']['id'],
    FileRoutesByPath['/arc/_ARCLayout']['path'],
    FileRoutesByPath['/arc/_ARCLayout']['fullPath']
  >
}
declare module './routes/auth/AuthLayout' {
  const createFileRoute: CreateFileRoute<
    '/auth/_AuthLayout',
    FileRoutesByPath['/auth/_AuthLayout']['parentRoute'],
    FileRoutesByPath['/auth/_AuthLayout']['id'],
    FileRoutesByPath['/auth/_AuthLayout']['path'],
    FileRoutesByPath['/auth/_AuthLayout']['fullPath']
  >
}
declare module './routes/arc/Home.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/',
    FileRoutesByPath['/arc/_ARCLayout/']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/']['id'],
    FileRoutesByPath['/arc/_ARCLayout/']['path'],
    FileRoutesByPath['/arc/_ARCLayout/']['fullPath']
  >
}
declare module './routes/arc/SIPLayout' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout']['fullPath']
  >
}
declare module './routes/arc/offline/Offline.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/offline',
    FileRoutesByPath['/arc/_ARCLayout/offline']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/offline']['id'],
    FileRoutesByPath['/arc/_ARCLayout/offline']['path'],
    FileRoutesByPath['/arc/_ARCLayout/offline']['fullPath']
  >
}
declare module './routes/auth/reset-password/ResetPassword' {
  const createFileRoute: CreateFileRoute<
    '/auth/_AuthLayout/reset-password',
    FileRoutesByPath['/auth/_AuthLayout/reset-password']['parentRoute'],
    FileRoutesByPath['/auth/_AuthLayout/reset-password']['id'],
    FileRoutesByPath['/auth/_AuthLayout/reset-password']['path'],
    FileRoutesByPath['/auth/_AuthLayout/reset-password']['fullPath']
  >
}
declare module './routes/auth/sign-in/SignIn' {
  const createFileRoute: CreateFileRoute<
    '/auth/_AuthLayout/sign-in',
    FileRoutesByPath['/auth/_AuthLayout/sign-in']['parentRoute'],
    FileRoutesByPath['/auth/_AuthLayout/sign-in']['id'],
    FileRoutesByPath['/auth/_AuthLayout/sign-in']['path'],
    FileRoutesByPath['/auth/_AuthLayout/sign-in']['fullPath']
  >
}
declare module './routes/auth/sign-up/SignUp' {
  const createFileRoute: CreateFileRoute<
    '/auth/_AuthLayout/sign-up',
    FileRoutesByPath['/auth/_AuthLayout/sign-up']['parentRoute'],
    FileRoutesByPath['/auth/_AuthLayout/sign-up']['id'],
    FileRoutesByPath['/auth/_AuthLayout/sign-up']['path'],
    FileRoutesByPath['/auth/_AuthLayout/sign-up']['fullPath']
  >
}
declare module './routes/arc/admin/Admin.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/admin',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/admin']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/admin']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/admin']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/admin']['fullPath']
  >
}
declare module './routes/arc/profile/Profile.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/profile',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/profile']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/profile']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/profile']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/profile']['fullPath']
  >
}
declare module './routes/arc/statistics/Statistics.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/statistics',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/statistics']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/statistics']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/statistics']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/statistics']['fullPath']
  >
}
declare module './routes/arc/CallLayout' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout']['fullPath']
  >
}
declare module './routes/arc/available/Available.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/available']['fullPath']
  >
}
declare module './routes/arc/call-in/CallIn.page' {
  const createFileRoute: CreateFileRoute<
    '/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling',
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling']['parentRoute'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling']['id'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling']['path'],
    FileRoutesByPath['/arc/_ARCLayout/_SIPLayout/call/_CallLayout/calling']['fullPath']
  >
}

interface arcCallLayoutRouteChildren {
  arcAvailableAvailableDotpageRoute: typeof arcAvailableAvailableDotpageRoute
  arcCallInCallInDotpageRoute: typeof arcCallInCallInDotpageRoute
}

const arcCallLayoutRouteChildren: arcCallLayoutRouteChildren = {
  arcAvailableAvailableDotpageRoute: arcAvailableAvailableDotpageRoute,
  arcCallInCallInDotpageRoute: arcCallInCallInDotpageRoute,
}

const arcCallLayoutRouteWithChildren = arcCallLayoutRoute._addFileChildren(
  arcCallLayoutRouteChildren,
)

interface arcSIPLayoutRouteChildren {
  arcAdminAdminDotpageRoute: typeof arcAdminAdminDotpageRoute
  arcProfileProfileDotpageRoute: typeof arcProfileProfileDotpageRoute
  arcStatisticsStatisticsDotpageRoute: typeof arcStatisticsStatisticsDotpageRoute
  arcCallLayoutRoute: typeof arcCallLayoutRouteWithChildren
}

const arcSIPLayoutRouteChildren: arcSIPLayoutRouteChildren = {
  arcAdminAdminDotpageRoute: arcAdminAdminDotpageRoute,
  arcProfileProfileDotpageRoute: arcProfileProfileDotpageRoute,
  arcStatisticsStatisticsDotpageRoute: arcStatisticsStatisticsDotpageRoute,
  arcCallLayoutRoute: arcCallLayoutRouteWithChildren,
}

const arcSIPLayoutRouteWithChildren = arcSIPLayoutRoute._addFileChildren(
  arcSIPLayoutRouteChildren,
)

interface arcARCLayoutRouteChildren {
  arcHomeDotpageRoute: typeof arcHomeDotpageRoute
  arcSIPLayoutRoute: typeof arcSIPLayoutRouteWithChildren
  arcOfflineOfflineDotpageRoute: typeof arcOfflineOfflineDotpageRoute
}

const arcARCLayoutRouteChildren: arcARCLayoutRouteChildren = {
  arcHomeDotpageRoute: arcHomeDotpageRoute,
  arcSIPLayoutRoute: arcSIPLayoutRouteWithChildren,
  arcOfflineOfflineDotpageRoute: arcOfflineOfflineDotpageRoute,
}

const arcARCLayoutRouteWithChildren = arcARCLayoutRoute._addFileChildren(
  arcARCLayoutRouteChildren,
)

interface authAuthLayoutRouteChildren {
  authResetPasswordResetPasswordRoute: typeof authResetPasswordResetPasswordRoute
  authSignInSignInRoute: typeof authSignInSignInRoute
  authSignUpSignUpRoute: typeof authSignUpSignUpRoute
}

const authAuthLayoutRouteChildren: authAuthLayoutRouteChildren = {
  authResetPasswordResetPasswordRoute: authResetPasswordResetPasswordRoute,
  authSignInSignInRoute: authSignInSignInRoute,
  authSignUpSignUpRoute: authSignUpSignUpRoute,
}

const authAuthLayoutRouteWithChildren = authAuthLayoutRoute._addFileChildren(
  authAuthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  indexRoute: indexRoute,
  NotFoundRoute: NotFoundRoute,
  dashboardDashboardDotpageRoute: dashboardDashboardDotpageRoute,
  monitorMonitorDotpageRoute: monitorMonitorDotpageRoute,
  arcARCLayoutRoute: arcARCLayoutRouteWithChildren,
  authAuthLayoutRoute: authAuthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
